import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from 'styled-components';
import { getColor } from '../../V2/Elements/Icons/helpers';
const Icon = React.forwardRef(function Icon({ size = 24, alt, color, className, onClick }, ref) {
    const theme = useTheme();
    const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
    return (_jsx("svg", { ref: ref, onClick: onClick, width: size, height: size, viewBox: '0 0 512 512', className: className, children: _jsxs("g", { transform: 'translate(16.006276, 0.000000)', fill: fillColor, children: [_jsx("polygon", { points: '360.384 0 182.698667 311.274667 297.194667 512 416.810667 512 302.314667 311.274667 480 0' }), _jsx("polygon", { points: '133.226667 96 20.4586667 96 85.696 210.901333 0 352 112.768 352 198.464 210.901333' })] }) }));
});
export default React.memo(Icon);
